'use strict';

define('auth_popups',['jquery.amd', 'underscore'], function ($, _) {
  var tknfa = /&tknfa=[^&]+/;

  function loadImg(url) {
    var dfd = new $.Deferred(), i = new Image();
    var done = function () {
      dfd.resolve(url);
    };
    var src = url + '?_=' + _.now();
    i.onload = done;
    i.onerror = done;
    _.defer(function () {
      i.src = src;
    });
    return dfd.promise();
  }

  function logoutProviders(urls) {
    var providers = _(urls);
    return (providers.isArray() && !providers.isEmpty()) ?
      $.when.apply($, providers.map(loadImg).value()) :
      (new $.Deferred()).resolve(urls).promise();
  }

  return function (sessionId) {
    $('a[data-popup]').unbind().click(function (e) {
      e.preventDefault();
      var data = $(this).data(),
        href = $(this).attr('href'),
        l = window.location,
        popupWindow,
        popup,
        pop = {
          left: 0,
          top: 0,
          width: data.popupWidth || 1025,
          height: data.popupHeight || 640
        };

      if (/logout/.test(href)) {
        return $.jsonp({
          url: href,
          cache: false
        }).then(function (urls) {
          logoutProviders(urls);
          if (tknfa.test(l.search)) {
            window.location = l.protocol + '//' + l.host + l.pathname + l.search.replace(tknfa, '');
          } else {
            // Clear all the current databags.
            _.invoke(window.nvtag.data, 'clear');
            // Make a call to FastAction to get another session id.
            require('fastActionUser').clear().fetch({cache: false});
          }
        });
      }

      if ('popupTop' in data && 'popupLeft' in data) {
        pop.top = ~~data.popupTop;
        pop.left = ~~data.popupLeft;
      } else if (screen && screen.width && screen.height) {
        pop.top = ~~((screen.height / 2) - (pop.height / 2));
        pop.left = ~~((screen.width / 2) - (pop.width / 2));
      }

      if (sessionId) {
        var idx = _.indexOf(href, '#');
        var base, hash, qs = '?fastActionSessionId=' + encodeURIComponent(sessionId);
        if (idx > 0) {
          base = href.substr(0, idx);
          hash = href.substr(idx);
          href = base + qs + hash;
        } else {
          href += qs;
        }
      }

      popup = {
        url: href,
        name: 'FastAction',
        options: 'toolbar=0,menubar=0,location=0,status=0,scrollbars=1,resizable=0,' + $.param(pop).replace(/&/g, ',')
      };

      popupWindow = window.open(popup.url, popup.name, popup.options);

      var onPopupClosed = function (callback) {
        var closePopup = function () {
          if (popupWindow.closed) {
            if (window.location.hash) {
              window.location.hash = '!';
            }
            callback();
          } else {
            setTimeout(closePopup, 1000 / 60);
          }
        };
        setTimeout(closePopup, 1000 / 60);
      };

      if (/auth/.test(popup.url)) {
        onPopupClosed(function () {
          require('fastActionUser').fetch({cache: false});
        });
      } else if (/profile/.test(popup.url)) {
        onPopupClosed(function () {
          require('fastActionUser').fetch({cache: false, clear: true}).then(function () {
            require('fast_databag').fetch({cache: false});
          });
        });
      }
    });
  };
});

